import { createAnalysisPage } from '@/features/analysisPage/components/AnalysisPageFactory';

export const AnalysisPublicPage = createAnalysisPage({
  type: 'public',
  baseRoute: '/analysis/public',
});
